import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import {
  InputUI,
  AutoCompleteSelectUI,
  FormErrorUI,
  FormLabelUI,
  CheckboxUI,
  ChromeColorPickerUI,
} from '../../Interface';
import { Popover } from '@mui/material';
import useParam from '../../../context/ParamContext';

export const ResourceOneFields = ({ viewField, selectedValues, autocompleteOptions }) => {
  const { params } = useParam();
  const { values, validateField, setFieldValue, errors } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (!viewField) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 ">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Erőforrás neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name !== '' }}
        />
      </div>
      <div className={selectedValues.generatedName ? 'col-span-4' : 'hidden'}>
        <Field
          type="text"
          name="generatedName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Összefűzött erőforrás név" />}
          variant="standard"
          disabled
          InputLabelProps={{ shrink: values.generatedName !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="groupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Erőforrás csoportja" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.groupId} />}
          onChange={(_e, newVal) => {
            setFieldValue('groupId', newVal?.value ?? null).then(() => {
              validateField('groupId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.groupId !== '' }}
          selectedValue={values.groupId}
          selectedLabelValue={selectedValues?.resourceGroup?.itemName}
          dataset={autocompleteOptions?.resourceGroup}
        />
      </div>
      {params.HIDE_RES1_RESOURCEONE_GROUP_FIELD !== 'Y' && (
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="resourceOneGroupId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Csoport" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.resourceOneGroupId} />}
            onChange={(_e, newVal) => {
              setFieldValue('resourceOneGroupId', newVal?.value ?? null).then(() => {
                validateField('resourceOneGroupId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.resourceOneGroupId !== '' }}
            selectedValue={values.resourceOneGroupId}
            selectedLabelValue={selectedValues?.resourceOneGroup?.name}
            dataset={autocompleteOptions?.resourceOneGroup}
          />
        </div>
      )}
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="statusId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Státusz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.statusId} />}
          onChange={(_e, newVal) => {
            setFieldValue('statusId', newVal?.value ?? null).then(() => {
              validateField('statusId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.statusId !== '' }}
          selectedValue={values.statusId}
          selectedLabelValue={selectedValues?.status?.itemName}
          dataset={autocompleteOptions?.status}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="typeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.typeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('typeId', newVal?.value ?? null).then(() => {
              validateField('typeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.typeId !== '' }}
          selectedValue={values.typeId}
          selectedLabelValue={selectedValues?.type?.itemName}
          dataset={autocompleteOptions?.type}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="classificationId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Besorolás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.classificationId} />}
          onChange={(_e, newVal) => {
            setFieldValue('classificationId', newVal?.value ?? null).then(() => {
              validateField('classificationId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.classificationId !== '' }}
          selectedValue={values.classificationId}
          selectedLabelValue={selectedValues?.classification?.name}
          dataset={autocompleteOptions?.classification}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="number"
          name="costPerHour"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Költség /óra" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costPerHour} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costPerHour !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="phoneNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.phoneNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.phoneNumber !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="email"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Email" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.email} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.email !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="position"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Pozíció" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.position} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.position !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="specialization"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Szakterület" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.specialization} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.specialization !== '' }}
        />
      </div>
      <div className="md:col-span-1 col-span-4 pt-4">
        <div
          className={`${!viewField ? 'cursor-pointer' : 'cursor-not-allowed'} rounded-full shadow-[rgba(0,_0,_0,_0.54)_0px_1px_8px] w-[20px] h-[20px] mt-1`}
          style={{ background: values.color }}
          onClick={handlePopoverOpen}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
        >
          <ChromeColorPickerUI
            color={values.color}
            onChange={(color) => {
              setFieldValue('color', color.hex);
            }}
          />
        </Popover>
      </div>
      <div className="md:col-span-2 col-span-4 pt-2">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};
